import { render, staticRenderFns } from "./workshop-transfer-select.vue?vue&type=template&id=5dcce5a6&scoped=true&"
import script from "./workshop-transfer-select.vue?vue&type=script&lang=js&"
export * from "./workshop-transfer-select.vue?vue&type=script&lang=js&"
import style0 from "./workshop-transfer-select.vue?vue&type=style&index=0&id=5dcce5a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcce5a6",
  null
  
)

export default component.exports